import { defineMessages, useIntl } from 'react-intl'
import { Heading, Text, Card } from '@homebotapp/hb-react-component-catalog'

// Components
import { Page } from '../../../..'
import { OverlayQuestionsFooter } from '../../../Routing'

// Constants
import { CUSTOMER_MESSAGES } from '../../../../../constants/customerMessages'

interface LearnMoreProps {
  withCurrentHomeData: boolean
}

export const MSG = defineMessages({
  heading: {
    id: 'Homeowner.interest.info.headline',
    defaultMessage: 'Paying extra is a way to save'
  },
  first: {
    id: 'Homeowner.interest.info.content1',
    defaultMessage:
      "If you are able to pay a little extra to your principal each month, it'll cut down significantly on how much interest you pay in the long run. The best part is that there's no paperwork, fees or headaches."
  },
  second: {
    id: 'Homeowner.interest.info.content2',
    defaultMessage: 'You just pay the extra amount you want onto your principal (not into your escrow).'
  }
})

export const LearnMore = ({ withCurrentHomeData }: LearnMoreProps) => {
  const intl = useIntl()

  return (
    <Page>
      <Card padding='8'>
        <Heading marginBottom='8'>{intl.formatMessage(MSG.heading)}</Heading>
        <Text>{intl.formatMessage(MSG.first)}</Text>
        <Text>{intl.formatMessage(MSG.second)}</Text>
        <Page.Disclaimer />
      </Card>
      {withCurrentHomeData && (
        <Page.Footer>
          <OverlayQuestionsFooter
            topic={CUSTOMER_MESSAGES.PRINCIPAL_PAYMENTS.topic}
            topicKey={CUSTOMER_MESSAGES.PRINCIPAL_PAYMENTS.topicKey}
            questions={[
              CUSTOMER_MESSAGES.PRINCIPAL_PAYMENTS.message,
              CUSTOMER_MESSAGES.PRINCIPAL_PAYMENTS.secondaryMessage
            ]}
            placeholder
          />
        </Page.Footer>
      )}
    </Page>
  )
}
